/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// import IconButton from "@material-ui/core/IconButton"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { useSnackbar } from "notistack";
import PrescriptionTable from "./PrescriptionTable";
import { useSelector } from "react-redux";
// import { MdAdd, MdRemove } from "react-icons/md"
import Service from "../../Service/firebase";
import { set } from "date-fns";

// import Button from "components/CustomButtons/Button"
const useStyles = makeStyles((theme) =>
	createStyles({
		container: {
			fontFamily: "Poppins",
		},
		root: {
			display: "flex",
			//   justifyContent: "center",
			flexWrap: "wrap",
			"& > *": {
				margin: theme.spacing(0.5),
			},
			marginBottom: theme.spacing(3),
		},
		defaultChip: {
			color: theme.palette.grey[800],
			background: theme.palette.grey[200],
			fontWeight: 500,
			"&:hover": {
				background: "inherit",
			},
		},
		activeChip: {
			//   color: theme.palette.secondary.dark,
			color: "rgba(53,89,209,1)",
			background: "#DADDFF",
			//   background: theme.palette.grey[300],
			fontWeight: 500,
			"&:hover": {
				background: "inherit",
				color: "inherit",
			},
		},
		titleRoot: {
			color: theme.palette.grey[100],
			background: "rgba(53,89,209,1)",
			//   background: theme.palette.secondary.dark,
			padding: `${theme.spacing(5)}px 2rem`,
			textTransform: "lowercase",
		},
	})
);

const AddDrug = () => {
	const reduxDetails = useSelector((state) => state.personDetails);
	// console.log("my new reduxDetails", reduxDetails);
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	// const [open, setOpen] = React.useState<boolean>(false)
	const [dosage, setDosage] = React.useState(1);
	const [instructions, setInstructions] = React.useState("");
	const [drugName, setDrugName] = React.useState("");
	const [strength, setStrength] = React.useState("");
	const [quantity, setQuantity] = React.useState("");
	const [symptom, setSymptom] = React.useState("");
	const [quantityVals, setQuantityVals] = React.useState("");
	const [ID, setID] = React.useState("");
	const [note, setNote] = React.useState("");
	const [open, setOpen] = React.useState(false);
	const [prescribedDrugsList, setPrescribedDrugsList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [duration, setDuration] = React.useState(1);
	const [me, setMe] = useState([]);
	const [repeat, setRepeat] = React.useState("Everyday");
	const [timeOfDay, setTimeOfDay] = React.useState([]);
	const [toBeTaken, setToBeTaken] = React.useState("After Food");
	const [medicine, setMedicine] = React.useState([]);
	const [isDrug, setIsDrug] = React.useState(false);
	const handleClickOpen = () => {
		setOpen(true);
		setIsDrug(true);
	};
	const handleClickOpen2 = () => {
		setOpen(true);
		setIsDrug(false);
	};
	// console.log("prescribed drug", prescribedDrugsList);
	const firebaseData2 = async () => {
		const res = await Service.getMedicine();
		// console.log(res, "new log");
		if (res === "error") {
			console.log("Error in get person details data");
		} else {
			setMedicine(res);
			// setIsLoading(false);
		}
	};
	const quantityData = quantityVals && quantityVals - quantity;
	// console.log(quantityData, "business");
	const onAddDrug = async () => {
		// console.log(drugName);
		if (!drugName || !strength || !instructions) {
			enqueueSnackbar("Please input all fields", {
				variant: "error",
			});
		} else {
			setPrescribedDrugsList((prev) => [
				...prev,
				{ drugName, strength, instructions, note, symptom },
			]);
			setDrugName("");
			setInstructions("");
			setStrength("");
			setQuantity("");
			setNote("");
			setSymptom("");
			setOpen(false);
			setIsLoading(true);

			// push to firebase
			await Service.addPatprescriptions(
				{ drugName, strength, instructions, note: note ? note : "-", symptom },
				"patients",
				reduxDetails.patientid
			).then(() => setIsLoading(false));

			await Service.updateMedicine("medicines", ID, quantityData);
		}

		// get from firebase
	};
	const onAddDrug2 = async () => {
		setNote("");
		setOpen(false);
		setIsLoading(true);
		await Service.addPatprescriptions(
			{ drugName: "-", strength: ["-"], instructions: "-", note, symptom },
			"patients",
			reduxDetails.patientid
		).then(() => setIsLoading(false));
		await Service.updateMedicine("medicines", ID, quantityData);
	};

	// get from firebase
	// console.log("fetched data;", me);

	React.useEffect(() => {
		setInstructions(
			`${dosage} tablet${dosage > 1 ? "s" : ""} ${repeat} for ${duration} week${
				duration > 1 ? "s" : ""
			} in the ${timeOfDay.join(", ")} ${toBeTaken}`
		);
		firebaseData2();
	}, [dosage, duration, repeat, timeOfDay, toBeTaken]);

	React.useEffect(() => {
		const test = medicine.filter(
			(r) => drugName !== "" && r?.name.includes(drugName)
		);
		const strengthval = test?.map((r) => r?.strength);
		const quantityVal = test?.map((r) => r?.qty);
		const idVal = test?.map((r) => r?.medicineid);
		setID(idVal[0]);
		setStrength(strengthval);
		setQuantityVals(quantityVal);

		// console.log(quantityVals, "quantity values", ID);
	}, [drugName]);
	const handleClose = () => {
		setOpen(false);
		setDrugName("");
		setInstructions("");
		setStrength("");
		setQuantity("");
		setNote("");
		setSymptom("");
	};

	return isLoading ? (
		<div className="addpersonpage">
			<i className="fas fa-spinner fa-pulse fa-2x"></i>
		</div>
	) : (
		<div className={classes.container}>
			<div className="flex justify-center space-x-2">
				<Button
					variant="outlined"
					// disabled={!diagnosis}
					color="primary"
					className="mb-2"
					onClick={handleClickOpen}
				>
					Add Drug
				</Button>
				<Button
					variant="outlined"
					// disabled={!diagnosis}
					color="primary"
					className="mb-2"
					onClick={handleClickOpen2}
				>
					Test to be done
				</Button>
			</div>

			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"

				// maxWidth="md"
			>
				{isDrug && (
					<DialogTitle
						id="form-dialog-title"
						classes={{ root: classes.titleRoot }}
					>
						{instructions}
					</DialogTitle>
				)}
				<DialogContent>
					{isDrug ? (
						<>
							<Grid container className="align-baseline">
								<TextField
									autoFocus
									margin="dense"
									id="note"
									label="Symptoms"
									type="text"
									fullWidth
									multiline
									onChange={(e) => setSymptom(e.target.value)}
									value={symptom}
								/>
								<Grid item sm={5} className="mt-3">
									<div className="col-md-6">
										{/* <label htmlFor="validationDefault11">Drug Name</label> */}
										<select
											name="medicinecategory"
											className="custom-select"
											multiple={false}
											placeholder="Drug Name"
											id="medicinecategory"
											value={drugName}
											style={{ width: "200px", fontSize: "14px" }}
											onChange={(e) => setDrugName(e.target.value)}
											required
										>
											(
											<option className="text-xl text-black capitalize">
												--select--
											</option>
											{medicine.map((meds) => (
												<option
													key={meds?.medicineid}
													className="text-xl text-black capitalize"
												>
													{meds?.name}
												</option>
											))}
										</select>
									</div>
								</Grid>
								<Grid item sm={4}>
									<TextField
										margin="dense"
										id="strength"
										label="Strength"
										type="text"
										disabled={true}
										fullWidth
										onChange={(e) => setStrength(e.target.value)}
										value={strength}
									/>
								</Grid>
								<Grid item sm={3}>
									<TextField
										margin="dense"
										id="quantity"
										label="quantity"
										type="text"
										fullWidth
										onChange={(e) => setQuantity(e.target.value)}
										value={quantity}
									/>
									{drugName !== ""
										? quantityVals < 1 && (
												<p className="text-red-500 text-sm">
													Quantity is less than 1{" "}
												</p>
										  )
										: null}
								</Grid>
							</Grid>
							<Grid container>
								<Grid item sm={6}>
									<Typography variant="caption" display="block">
										Dosage
									</Typography>

									<i
										onClick={() =>
											dosage > 1 && setDosage((d) => (d <= 0 ? 1 : d - 1))
										}
										className="fa fa-arrow-circle-o-right fa-2x"
										aria-hidden="true"
									></i>
									<Typography display="inline">{dosage} tablet</Typography>

									<i
										onClick={() => setDosage((d) => d + 1)}
										className="fa fa-arrow-circle-o-right fa-2x"
										aria-hidden="true"
									></i>
								</Grid>
								<Grid item sm={6}>
									<Typography variant="caption" display="block">
										Duration (Week)
									</Typography>

									<i
										onClick={() => setDuration((d) => (d <= 1 ? 1 : d - 1))}
										className="fa fa-arrow-circle-o-right fa-2x"
										aria-hidden="true"
									></i>
									<Typography display="inline">{duration} week</Typography>

									<i
										onClick={() => setDuration((d) => d + 1)}
										className="fa fa-arrow-circle-o-right fa-2x"
										aria-hidden="true"
									></i>
								</Grid>
							</Grid>
							<Typography variant="caption">Repeat</Typography>
							<div className={classes.root}>
								{["Everyday", "Alternate Days", "Specific Days"].map(
									(day, i) => (
										<Chip
											key={day + i}
											label={day}
											color="secondary"
											onClick={() => setRepeat(day)}
											classes={{
												colorSecondary:
													day === repeat
														? classes.activeChip
														: classes.defaultChip,
											}}
										/>
									)
								)}
								{repeat !== "Everyday" && (
									<TextField
										autoFocus
										margin="dense"
										id="repeat"
										label="Enter Day(s)"
										type="text"
										onChange={(e) => setRepeat(e.target.value)}
									/>
								)}
							</div>
							<Typography variant="caption">Time of day</Typography>
							<div className={classes.root}>
								{["Morning", "Noon", "Evening", "Night"].map((day, i) => (
									<Chip
										key={day + i}
										label={day}
										color="secondary"
										onClick={() =>
											setTimeOfDay((prev) =>
												!prev.includes(day)
													? [...prev, day]
													: prev.filter((item) => item !== day)
											)
										}
										classes={{
											colorSecondary: timeOfDay.includes(day)
												? classes.activeChip
												: classes.defaultChip,
										}}
									/>
								))}
							</div>
							<Typography variant="caption">To be taken</Typography>
							<div className={classes.root}>
								{["Before Food", "After Food"].map((time, i) => (
									<Chip
										key={i + time}
										label={time}
										color="secondary"
										onClick={() => setToBeTaken(toBeTaken !== time ? time : "")}
										classes={{
											colorSecondary:
												toBeTaken === time
													? classes.activeChip
													: classes.defaultChip,
										}}
									/>
								))}
							</div>
							<TextField
								autoFocus
								margin="dense"
								id="note"
								label={isDrug ? "Doctor note" : "Test to be done"}
								type="text"
								fullWidth
								multiline
								onChange={(e) => setNote(e.target.value)}
								value={note}
							/>
						</>
					) : (
						<div>
							<TextField
								autoFocus
								margin="dense"
								id="note"
								label="Symptoms"
								type="text"
								fullWidth
								multiline
								onChange={(e) => setSymptom(e.target.value)}
								value={symptom}
							/>
							<TextField
								autoFocus
								margin="dense"
								id="note"
								label={isDrug ? "Doctor note" : "Test to be done"}
								type="text"
								fullWidth
								multiline
								onChange={(e) => setNote(e.target.value)}
								value={note}
							/>
						</div>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="secondary">
						Cancel
					</Button>
					<Button onClick={isDrug ? onAddDrug : onAddDrug2} color="secondary">
						{isDrug ? " Add Drug " : "Add Test"}
					</Button>
				</DialogActions>
			</Dialog>

			<div>
				<PrescriptionTable
					prescribedDrugsList={prescribedDrugsList}
					fetchedData={me}
				/>
			</div>
		</div>
	);
};

export default AddDrug;
